import Vue from 'vue'

const state = {
	listItemData: {},
};

const controller = new AbortController();
const signal = controller.signal;


const getters = {
	getItemData: (state) => {

		return state.listItemData;
	},
	cancelItemRequest: () => {
		alert('Cancel...');
		if (controller) controller.abort();
		
		
	},
	
};

const mutations = {
	updateItemData: (state, payload) => {
		Vue.set(state.listItemData, payload.prop, payload.value);
	},
};

const actions = {
	getItemData: ({ commit }, order_serial) => {

		
		fetch(process.env.VUE_APP_ITEM + "?order_serial=" + order_serial,  { signal })
			.then((data) => data.json())
			.then((data) => {
				commit('updateItemData', { prop: order_serial, value: data } );
			})
			.catch((err) => {
				//window.alert('error - see dev console for more details');
				console.error(err);
			});
	},
};

export default {
	state,
	mutations,
	getters,
	actions,
};
